import { api } from './api';

// Organization CRUD
export const createOrganization = async (data) => {
  const response = await api.post('/organizations', data);
  return response.data;
};

export const getOrganizations = async () => {
  const response = await api.get('/organizations');
  return response.data;
};

export const getOrganization = async (orgId) => {
  const response = await api.get(`/organizations/${orgId}`);
  return response.data;
};

export const updateOrganization = async (orgId, data) => {
  const response = await api.put(`/organizations/${orgId}`, data);
  return response.data;
};

export const deleteOrganization = async (orgId) => {
  const response = await api.delete(`/organizations/${orgId}`);
  return response.data;
};

// Organization Members
export const getOrganizationMembers = async (orgId) => {
  const response = await api.get(`/organizations/${orgId}/members`);
  return response.data;
};

export const addOrganizationMember = async (orgId, data) => {
  const response = await api.post(`/organizations/${orgId}/members`, data);
  return response.data;
};

export const updateOrganizationMember = async (orgId, userId, data) => {
  const response = await api.put(`/organizations/${orgId}/members/${userId}`, data);
  return response.data;
};

export const removeOrganizationMember = async (orgId, userId) => {
  const response = await api.delete(`/organizations/${orgId}/members/${userId}`);
  return response.data;
};

export const leaveOrganization = async (orgId) => {
  const response = await api.post(`/organizations/${orgId}/leave`);
  return response.data;
};

// Organization Invites
export const createOrganizationInvite = async (orgId, data = {}) => {
  const response = await api.post(`/organizations/${orgId}/invites`, data);
  return response.data;
};

export const getOrganizationInvites = async (orgId) => {
  const response = await api.get(`/organizations/${orgId}/invites`);
  return response.data;
};

export const revokeOrganizationInvite = async (orgId, inviteId) => {
  const response = await api.delete(`/organizations/${orgId}/invites/${inviteId}`);
  return response.data;
};

// Public invite endpoints (no auth required for GET)
export const getInviteDetails = async (token) => {
  const response = await api.get(`/organizations/invite/${token}`);
  return response.data;
};

export const acceptOrganizationInvite = async (token) => {
  const response = await api.post(`/organizations/join/${token}`);
  return response.data;
};

// Helper to generate invite link
export const generateInviteLink = (token) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/invite/org/${token}`;
};

// Slack Integration
export const testSlackWebhook = async (orgId) => {
  const response = await api.post(`/organizations/${orgId}/test-slack-webhook`);
  return response.data;
};

// JIRA Integration
export const getOrgJiraSettings = async (orgId) => {
  const response = await api.get(`/organizations/${orgId}/settings/jira`);
  return response.data;
};

export const saveOrgJiraSettings = async (orgId, settings) => {
  const response = await api.put(`/organizations/${orgId}/settings/jira`, settings);
  return response.data;
};

export const clearOrgJiraSettings = async (orgId) => {
  const response = await api.delete(`/organizations/${orgId}/settings/jira`);
  return response.data;
};

const organizationsApi = {
  createOrganization,
  getOrganizations,
  getOrganization,
  updateOrganization,
  deleteOrganization,
  getOrganizationMembers,
  addOrganizationMember,
  updateOrganizationMember,
  removeOrganizationMember,
  leaveOrganization,
  createOrganizationInvite,
  getOrganizationInvites,
  revokeOrganizationInvite,
  getInviteDetails,
  acceptOrganizationInvite,
  generateInviteLink,
  testSlackWebhook,
  getOrgJiraSettings,
  saveOrgJiraSettings,
  clearOrgJiraSettings,
};

export default organizationsApi;
